import * as React from 'react';
const BasePropsContext = React.createContext({});
export function withBaseProps(WrappedComponent) {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const ComponentWithBaseProps = (props) => {
        return (React.createElement(BasePropsContext.Provider, { value: props },
            React.createElement(WrappedComponent, { ...props })));
    };
    ComponentWithBaseProps.displayName = `withBaseProps(${displayName})`;
    return ComponentWithBaseProps;
}
export const useBaseProps = () => React.useContext(BasePropsContext);
